// `./components` subpath export — the compiled MDX catalogue (`getSlidesComponents`).
// Resolvable only under Metro; see `components.metro.ts`. Slug helpers live on the root export.
export { getQuizComponents, getSlidesComponents, type SlideComponent } from "#components-metro";
